<template>
  <div class="app">
    <RouterHeader @change='change' :lan='lan' :n='index' />
    <router-view class="routerbox" :lan='lan' @change="changeTab" />
    <router-footer :lan='lan' />
  </div>
</template>
<script>
  import RouterHeader from '@/components/RouterHeader.vue'
  import RouterFooter from '@/components/RouterFooter.vue';
  export default {
    components: {
      RouterHeader,
      RouterFooter
    },
    data() {
      return {
        lan: 'cn',
        index: 0,
        detail: '',
      }
    },
    methods: {
      change() {
        let lans = sessionStorage.getItem('lan');
        this.lan = lans
        if (this.$route.path == '/WineCultureBreed') {
          this.$router.go(-1)
          // setTimeout(() => {
          //   alert('已进行中英切换，请再次点击你要查看的品种风格')
          // }, 100);
          return
        }
        if (this.$route.path == '/InformationDetails') {
          this.$router.push('/InformationList')
          // setTimeout(() => {
          //   alert('已进行中英切换，请再次点击你要查看的资讯')
          // }, 100);
          return
        }
        if (this.$route.path == '/ProductDetails') {
          if (this.$route.query.type == "ProductList") {
            this.$router.push('/ProductList')
            // setTimeout(() => {
            //   alert('已进行中英切换，请再次点击你要查看的红酒详情')
            // }, 100);
          } else {
            this.$router.push('/WineryList')
            // setTimeout(() => {
            //   alert('已进行中英切换，请再次点击你要查看的酒庄详情')
            // }, 100);
          }
          return
        }
        if (this.$route.path == '/WineryDetails') {
          this.$router.push('/WineryList')
          // setTimeout(() => {
          //   alert('已进行中英切换，请再次点击你要查看的酒庄详情')
          // }, 100);
          return
        }
      },
      changeTab(i) {
        this.index = i
      },
      seo() {
        this.$http.post("/index/seo/list", {}).then((res) => {
          if (res.data.code == 0) {
            this.detail = res.data.data;
            document.title = res.data.data.title
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.description)
            console.log(res.data.data);
          }
        });
      },
    },
    mounted() {
      let lan = sessionStorage.getItem('lan');
      if (lan == null) {
        sessionStorage.setItem('lan', "cn");
      } else {
        this.lan = lan
      }
      this.seo()
    },
  };
</script>
<style>
  * {
    font-family: Italic, Regular,Italicc !important;
  }

  img {
    object-fit: cover;
    display: block;
  }

  video {
    object-fit: cover;
    display: block;
  }
</style>
<style lang="scss">
  .index {
    .swiper1 {
      position: relative;

      .box {
        position: absolute;
        width: 100%;
        height: 100px;

        @media (max-width: 1199px) {
          height: auto;
        }

        top: 50%;
        transform: translate(0%, -50%);
        // left: 25%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        text-align: center;

        .content {
          font-size: 69px;
          color: #FFFFFF;
          line-height: 100px;
          font-weight: lighter;

          @media (max-width: 1199px) {
            font-size: 30px;
            line-height: 70px;
          }
        }
      }
    }
  }

  .line {
    width: 100px;
    height: 4px;
    margin-top: 10px;
    display: flex;
    background-color: #F1F1F1;
    justify-content: space-between;

    :first-child {
      width: 33.33%;
      background-color: #009344;
    }

    :last-child {
      width: 33.33%;
      background-color: #EE3D42;
    }
  }

  .winery {
    width: 100%;

    // background-color: red;
    >:first-child {
      text-align: center;
      font-size: 30px;

      @media (max-width: 1199px) {
        font-size: 20px !important;
      }

      font-family: Italicc !important;
      font-weight: normal;
      color: #C5A176;
    }

    >:nth-child(2) {
      text-align: center;
      margin-top: 10px;
      font-size: 30px;

      @media (max-width: 1199px) {
        font-size: 24px !important;
      }

      font-family: Regular;
      font-weight: 500;
      color: #6F655D;
    }

    >:nth-child(3) {
      margin: auto;
      margin-top: 10px;
    }

    >:nth-child(4) {
      text-align: center;
      margin-top: 20px;
      font-size: 18px;

      @media (max-width: 1199px) {
        font-size: 14px !important;
        width: 90%;
        margin: auto;
        margin-top: 20px;
      }

      font-family: Italic;
      font-weight: 400;
      color: rgba(111, 101, 93, 0.8);
    }
  }

  .el-drawer__header {
    margin-bottom: 0px !important;
  }

  .el-drawer__close-btn {
    background-color: white !important;
  }

  .el-drawer__open .el-drawer.rtl {
    width: 60% !important;
    background: #333 !important;
    color: white !important;
  }

  .el-drawer.rtl {
    background: #333 !important;
    color: white !important;
  }

  .el-drawer__body>* {
    width: 100% !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    padding: 0px 10px !important;
    border-bottom: 1px solid white !important;
  }

  .el-drawer__body>* :first-child {
    border-top: 1px solid white !important;
  }

  .routerbox {

    // padding-top: 111px;
    @media (max-width: 1199px) {
      padding-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue